import { ArrowRight, Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useVerticalUI } from '@/lib/verticalUI/useVerticalUI'
import type { DashboardStats } from '@/services/dashboardApi'
import { DashboardCard } from './DashboardCard'
import { ChannelRow } from './ChannelRow'

export interface ChannelsPanelProps {
  instances: DashboardStats['instances']
}

/** Canales conectados como filas reutilizables, sin bloques de tarjeta copiados. */
export function ChannelsPanel({ instances }: ChannelsPanelProps) {
  const navigate = useNavigate()
  const { profile } = useVerticalUI()
  const activeCount = instances.filter(
    (instance) => instance.status === 'WORKING' || instance.status === 'CONNECTED'
  ).length
  const customerRole = profile.terminology.customerRoleLabel.toLowerCase()

  return (
    <DashboardCard
      title="Canales Conectados"
      titleId="channels-title"
      state={instances.length === 0 ? 'empty' : 'success'}
      allowOverflow
      emptyMessage={`No hay canales configurados. Conecta WhatsApp o Telegram para empezar a atender a tus ${customerRole}s.`}
      emptyAction={
        <Button
          type="button"
          onClick={() => navigate('/app/instances?create=true')}
          className="bg-brand text-white hover:bg-brand-dark"
        >
          <Plus className="mr-2 h-4 w-4" aria-hidden="true" />
          Conectar canal
        </Button>
      }
      action={
        <div className="flex items-center gap-3">
          <span className="rounded-full bg-brand/10 px-2.5 py-1 text-xs font-bold text-brand">
            {activeCount} activos
          </span>
          <button
            type="button"
            onClick={() => navigate('/app/instances')}
            className="flex items-center gap-1 text-xs font-medium text-brand transition-colors hover:text-brand-dark"
          >
            Ver todos
            <ArrowRight className="h-3 w-3" aria-hidden="true" />
          </button>
        </div>
      }
    >
      <div className="divide-y divide-slate-100">
        {instances.map((instance) => (
          <ChannelRow
            key={instance.id}
            instance={instance}
            onOpen={(instanceId) => navigate(`/app/instances/${instanceId}`)}
            onConversations={(instanceId) => navigate(`/app/conversations?instance=${instanceId}`)}
          />
        ))}
      </div>
    </DashboardCard>
  )
}
